import { getRecibosPDF } from 'api/recaudacion/recibos';
import Previewer from 'components/Previewer';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { SET_PADRON_REQUIERE_FETCH, SET_RECIBO_CONVENIO } from 'store/reducers/caja';

const ModalReciboConvenio = () => {
  const dispatch = useDispatch();
  const { reciboConvenio } = useSelector(({ caja }) => caja);
  const [visible, setVisible] = useState(false);
  const [base64, setBase64] = useState('');
  const [key, setKey] = useState('');

  useEffect(() => {
    let mounted = true;
    const fetchData = async () => {
      const [_recibosBase64] = await Promise.all([
        getRecibosPDF(reciboConvenio?.recibos.map(({ id }) => id)),
      ]);
      if (mounted) {
        setKey(reciboConvenio?.padron.key);
        setBase64(_recibosBase64.base64);
        setVisible(true);
      }
    };
    if (reciboConvenio?.recibos?.length) {
      fetchData();
    }
    return () => { mounted = false; };
  }, [reciboConvenio?.recibos]);

  return (
    <Previewer
      allowDownload
      allowSend
      visible={visible}
      setVisible={(_visible) => {
        if (!_visible) {
          dispatch({ type: SET_PADRON_REQUIERE_FETCH, payload: key });
          dispatch({ type: SET_RECIBO_CONVENIO });
          setBase64('');
          setVisible(false);
        }
      }}
      base64={base64}
    />
  );
};

export default ModalReciboConvenio;
